import { getRegeneronFormInitialValues } from "../../initialValuesUtils";

export const getRegeneronCopayFormInitialValues = ({ applicationForm, formJson }) => {
  const initialValues = getRegeneronFormInitialValues({ applicationForm, formJson });

  return initialValues;
};
